import {
  authControllerLogout,
  authControllerRefresh,
  authControllerTelegramAuth,
} from "../../shared/contracts";
import type { TokenPairDto } from "../../shared/contracts/model/tokenPairDto";
import type { FetcherConfig } from "../../shared/api/http";

export interface AuthApi {
  telegramAuth(initData: string, config: FetcherConfig): Promise<TokenPairDto>;
  refresh(refreshToken: string, config: FetcherConfig): Promise<TokenPairDto>;
  logout(config: FetcherConfig): Promise<void>;
}

export class HttpAuthApi implements AuthApi {
  async telegramAuth(initData: string, config: FetcherConfig): Promise<TokenPairDto> {
    return authControllerTelegramAuth({ initData }, config);
  }

  async refresh(refreshToken: string, config: FetcherConfig): Promise<TokenPairDto> {
    return authControllerRefresh({ refreshToken }, config);
  }

  async logout(config: FetcherConfig): Promise<void> {
    await authControllerLogout(config);
  }
}

